@if (busyIndicatorMessageManager.count() > 0) {
    <ws-busy-indicator [message]="busyIndicatorMessageManager.message"></ws-busy-indicator>
}
<ws-modal-wrapper headerLabel="Add Company Permissions"
                  headerHelpContentId="filing-batch-add-accounts.panel"
                  [suppressKeyboardEvents]="true"
                  (save)="save()"
                  (cancel)="cancel()"
                  [disableSave]="!gridTracker?.getSelectedRowsCount()">
    <div style="display: flex; align-items: center; justify-content: end; margin: 0;" class="checkbox">
        <label>
            <input type="checkbox" [(ngModel)]="excludeInactive" (change)="onExcludeInactive()"> Exclude Inactive
        </label>
    </div>
    <ag-grid-row-count [gridApi]="gridApi"
                       [gridTracker]="gridTracker"
                       [gridOptions]="gridOptions"
                       [prefix]="null"
                       [suffix]="null"></ag-grid-row-count>
    <ws-ag-grid-angular [gridOptions]="gridOptions"
                        (gridReady)="onAgGridReady($event)">
    </ws-ag-grid-angular>
    <br/>
    @if (gridTracker?.getSelectedRowsCount()) {
        <div class="mb-3">
            <label for="permission">Company Permissions:</label><br>
            <select id="permission"
                    name="permission"
                    class="form-select form-select-sm"
                    [(ngModel)]="selectedPermissionType">
                @for (p of permissionTypes; track p) {
                    <option [value]="p">
                        {{ p }}
                    </option>
                }
            </select>
        </div>
    }
</ws-modal-wrapper>
